// extracted by mini-css-extract-plugin
module.exports = {"btn":"new-batch__btn3SD","image":"new-batch__image1fj","image--fetching":"new-batch__image--fetching1Vc","spin":"new-batch__spinRoR"};